import { z } from 'zod';

import type { LOCATION_STATUS } from '../dictionary';

export const LocationIdSchema = z.number();
export type LocationId = z.infer<typeof LocationIdSchema>;

export type LocationStatus = (typeof LOCATION_STATUS)[keyof typeof LOCATION_STATUS];
